var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48214 11.5179H11.5179M3.48214 11.5179C2.59454 11.5179 1.875 10.7983 1.875 9.91071V6.29464C1.875 5.62894 2.41465 5.08929 3.08036 5.08929C3.22124 5.08929 3.35647 5.11346 3.48214 5.15787M3.48214 11.5179V13.125M11.5179 11.5179C12.4055 11.5179 13.125 10.7983 13.125 9.91071V6.29464C13.125 5.62894 12.5853 5.08929 11.9196 5.08929C11.7788 5.08929 11.6435 5.11346 11.5179 5.15787M11.5179 11.5179V13.125M3.48214 5.15787C3.9503 5.32334 4.28571 5.76982 4.28571 6.29464V8.30357H10.7143V6.29464C10.7143 5.76982 11.0497 5.32334 11.5179 5.15787M3.48214 5.15787V5.08929C3.48214 3.31408 4.92123 1.875 6.69643 1.875H8.30357C10.0787 1.875 11.5179 3.31408 11.5179 5.08929V5.15787",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.dff17b33f13172ccb26d2789e317d47b.svg";
export { ForwardRef as ReactComponent };